module.exports = __webpack_public_path__ + "img/126.6a07f2e5.png";